import { render, staticRenderFns } from "./panicBuying.vue?vue&type=template&id=791b6f00&"
import script from "./panicBuying.vue?vue&type=script&lang=js&"
export * from "./panicBuying.vue?vue&type=script&lang=js&"
import style0 from "./panicBuying.vue?vue&type=style&index=0&id=791b6f00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports